export const API_BASE = "https://backendminidiscord.onrender.com";
export const WEBSOCKET_URL = `${API_BASE}/ws`;
export const MESSAGES_API = `${API_BASE}/api/chat/messages`;
